import React from "react";
import CashAdvanceService from "../../../../services/CashAdvanceService";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  FormControlLabel,
  FormGroup,
  Typography,
} from "@mui/material";
import SignedContract from "../../../../components/Vectors/SignedContract";
import { DelendButton } from "../../../../components/Buttons";
import DelendLocalCentralizedCircularProgress from "../../../../components/CircularProgress/DelendLocalCentralizedCircularProgress";

const SignCreditRequestModal = ({
  opened,
  closeCallback,
  receivable,
  pdfBase64,
}) => {
  const [open, setOpen] = React.useState(opened);
  const [agreedLegalTerms, setAgreedLegalTerms] = React.useState(false);
  const [pdf, setPdf] = React.useState(pdfBase64);
  const [fetchedContract, setFetchedContract] = React.useState(false);
  const [cashAdvanceSigned, setCashAdvanceSigned] = React.useState(false);
  const [document, setDocument] = React.useState({});
  const [loading, setLoading] = React.useState(false);
  let navigate = useNavigate();

  React.useEffect(() => {
    const fetchDocument = async () => {
      const documentType = receivable.hasSigned
        ? "CASH_ADVANCE_APPEND"
        : "OPERATION_CONTRACT";
      setFetchedContract(true);
      setLoading(true);
      const response = await CashAdvanceService.createDocuments(
        receivable.uuid,
        documentType
      );
      if (response.data) {
        setDocument(response.data);
        setPdf(response.data.contractReceivableAppendBas64);
      }
      setLoading(false);
    };
    setOpen(opened);
    if (!document.uuid && opened && !fetchedContract) fetchDocument();
  }, [opened, document, receivable, fetchedContract]);

  const styles = {
    modalContainer: {
      padding: 32,
    },
  };

  const handleClose = (event, reason) => {
    setFetchedContract(false);
    setAgreedLegalTerms(false);
    closeCallback(false);
  };

  const signContract = async () => {
    setLoading(true);
    const resp = await CashAdvanceService.signCashAdvance(document.uuid);
    setLoading(false);
    if (resp.status === 200 || resp.status === 201) {
      if (document.type === "CASH_ADVANCE_APPEND") {
        setAgreedLegalTerms(false);
        setCashAdvanceSigned(resp.data);
      } else {
        setLoading(true);
        const response = await CashAdvanceService.createDocuments(
          receivable.uuid,
          "CASH_ADVANCE_APPEND"
        );
        setAgreedLegalTerms(false);
        if (response.data) {
          setDocument(response.data);
          setPdf(response.data.contractReceivableAppendBas64);
        }
        setLoading(false);
      }
    }
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      fullWidth
      maxWidth="md"
      aria-labelledby="modal-modal-title"
      scroll={"paper"}
      aria-describedby="modal-modal-description"
      style={styles.modalContainer}
    >
      {cashAdvanceSigned ? (
        <Box>
          <DialogContent style={{ textAlign: "center" }}>
            <SignedContract />
            <Typography
              sx={{ fontWeight: 600, mb: "24px" }}
              color="inherit"
              noWrap
            >
              Contratação efetuada com sucesso!
            </Typography>
            <Typography
              sx={{
                fontWeight: 400,
                color: "#8087A6",
                mb: "18px",
              }}
              color="inherit"
            >
              Para visualizar os detalhes dessa contratação, pressione o botão
              "Visualizar detalhes"
            </Typography>
          </DialogContent>
          <DialogActions style={{ padding: 12 }}>
            <Button
              variant="outlined"
              sx={{
                textTransform: "none",
                borderRadius: 50,
                mr: "24px",
                borderColor: "#E9EBF0",
              }}
              onClick={() => navigate("/dashboard/receivable")}
            >
              <Typography
                sx={{
                  fontWeight: 600,
                  fontSize: 14,
                }}
                color="inherit"
                noWrap
              >
                Gestão de vendas
              </Typography>
            </Button>
            <DelendButton
              text="Visualizar detalhes"
              autoFocus
              onClick={() =>
                navigate(
                  "/dashboard/anticipation/detail/" + cashAdvanceSigned?.uuid
                )
              }
            />
          </DialogActions>
        </Box>
      ) : (
        <Box>
          {loading ? (
            <Box style={{ height: "200px", marginTop: "100px" }}>
              {" "}
              <DelendLocalCentralizedCircularProgress />{" "}
            </Box>
          ) : (
            <Box>
              <DialogContent>
                {pdf && (
                  <iframe
                    title="pdf"
                    width={"100%"}
                    height={"550px"}
                    src={`data:application/pdf;base64,${pdf}`}
                  />
                )}
              </DialogContent>
              <Box style={{ padding: "0px 32px" }}>
                <FormGroup>
                  <FormControlLabel
                    required
                    control={
                      <Checkbox
                        checked={agreedLegalTerms}
                        onChange={(e) => setAgreedLegalTerms(!agreedLegalTerms)}
                        sx={{
                          marginTop: "-20px",
                        }}
                      />
                    }
                    label={
                      <Typography fontSize={13}>
                        {document.type === "CASH_ADVANCE_APPEND"
                          ? "Declaro que li e estou de acordo integralmente com o Termo Aditivo ao Contrato de Antecipação de Recebíveis a Fornecedores."
                          : "Declaro que li e estou de acordo integralmente com o Contrato de Antecipação de Recebíveis a Fornecedores."}
                      </Typography>
                    }
                  />
                </FormGroup>
              </Box>
              <DialogActions style={{ padding: 12 }}>
                <Button
                  variant="outlined"
                  sx={{
                    textTransform: "none",
                    borderRadius: 50,
                    mr: "24px",
                    borderColor: "#E9EBF0",
                  }}
                  onClick={handleClose}
                >
                  <Typography
                    sx={{
                      fontWeight: 600,
                      fontSize: 14,
                    }}
                    color="inherit"
                    noWrap
                  >
                    Recusar
                  </Typography>
                </Button>
                <DelendButton
                  disabled={!agreedLegalTerms || loading}
                  text="Concordar"
                  autoFocus
                  onClick={signContract}
                ></DelendButton>
              </DialogActions>
            </Box>
          )}
        </Box>
      )}
    </Dialog>
  );
};

export default SignCreditRequestModal;
